import { AddBuisnessPostComponent } from "./../../../shared/components/add-buisness-post/add-buisness-post.component";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { Component, OnInit, OnDestroy, NgZone } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { AddAdminPostComponent } from "src/app/shared/components/add-admin-post/add-admin-post.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { ActivatedRoute, Router } from "@angular/router";
import { NavigationService } from "../../../providers/navigation.service";
import { SharedService } from "src/app/providers/shared.service";
import { AddDiscountComponent } from "../../promotion/add-discount/add-discount.component";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { YoutubeEmbedVideoComponent } from "../../new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { MatSnackBar } from "@angular/material/snack-bar";
@Component({
  selector: "sm-coupons",
  templateUrl: "./coupons.component.html",
  styleUrls: ["./coupons.component.scss"],
})
export class BusinessCouponsComponent implements OnInit, OnDestroy {
  couponData: any = [];
  isfromhere:boolean = false
  public isLoading: boolean = false;
  protected apiSubscription: Subscription = new Subscription();
  constructor(
    private loader: LoaderServiceService,
    public _apiService: ApiService,
    private _snackbar: MatSnackBar,
    private dialog: MatDialog,
    public router: Router,
    public route: ActivatedRoute,
    public _navService: NavigationService,
    private sharedService: SharedService
  ) {
    this._navService.hideSidebarAndNav = false;
  }

  ngOnInit(): void {
    this.isLoading = true;
    console.log("called");
    this.loader.showLoader = true;
    this._apiService.getDiscountCouponsList();
    // this._apiService.getBusinessDetail()
    
    this.apiSubscription = this._apiService.apiResult.subscribe((data) => {
      // this.isLoading = true;
      // console.log(data);
      // console.log(data.result);
      // console.log(data.result.length);
      if (data.responseType === SM_CONSTANTS.GET_COUPONS_LIST_RESULT) {
        console.log(data);
        // this.isLoading=false
        if (data.result && data.result != null) {
          this.couponData = [];
          const getServiceType = (
            home_service_status: number,
            shop_service_status: number,
            virtual_service_status: number
          ) => {
            const combination =
              (home_service_status << 2) |
              (shop_service_status << 1) |
              virtual_service_status;

            switch (combination) {
              case 0b000:
                return "None"; // No services available
              case 0b001:
                return "Virtual";
              case 0b010:
                return "Shop";
              case 0b011:
                return "Shop + Virtual";
              case 0b100:
                return "Home";
              case 0b101:
                return "Home + Virtual";
              case 0b110:
                return "Shop + Home";
              case 0b111:
                return "Shop + Home + Virtual";
              default:
                return "Unknown";
            }
          };
          data.result.forEach((element: any) => {
            element.service_type = getServiceType(
              element.home_service_status,
              element.shop_service_status,
              element.virtual_service_status
            );
            this.couponData.push(element);
            // this.isLoading = false
          });
        } else {
          this.couponData = [];
          // this.isLoading = false
        }
        this.loader.showLoader = false;
        this.isLoading = false;
      }
      if (data.responseType === SM_CONSTANTS.GET_BUSINESS_LIST_RESULT) {
        console.log(data);
        // this.isLoading=false
      }
      if (data.responseType === SM_CONSTANTS.CREATE_DISCOUNT_COUPON_RESULT) {
        if(this.isfromhere){
          this.isfromhere = false
          if (data.result) {
            if (data.result.errorcode == 0) {
              this._apiService.getDiscountCouponsList();
            } else if (data.result.errorcode == 1) {
              this.loader.showLoader = false
              const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
                width: '400px',
                data: {
                  title: "Alert",
                  message:
                    "'" +
                    this.ddata.coupon_code +
                    "'" +
                    " coupon could not be enabled as there exists another active coupon with the same code. Either deactivate or delete it and then try again.",
                  okbtn: "Ok",
                  cancelbtn: "Cancel",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                },
                disableClose: true,
              });
            }
          }

        }
      }

      // if(data.result && data.result!= null)
      // {
      //   this.couponData=[];
      //   if(data.result.length > 1){
      //      data.result.forEach((element: any) => {
      //     this.couponData.push(element);
      //     this.isLoading = false
      //   });
      //   }else {
      //       this.couponData = data.result
      //       this.isLoading= false
      //   }
      // }else{
      //   this.couponData = []
      //   this.isLoading = false
      // }
    });
  }

  copymessage(item: any) {
    navigator.clipboard
      .writeText(item.description)
      .then(() => {
        this._snackbar.open("Coupon promo text copied", "Ok", {
          duration: 3000,
        });
        // Success message or feedback can be added here
        // alert('Message copied to clipboard');
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  }

  shareFacebook(item: any) {
    let link =
      "https://www.facebook.com/sharer/sharer.php?u=" +
      encodeURIComponent(item.description);
    window.open(link, "_blank");
  }

  shareTwitter(item: any) {
    let link =
      "https://twitter.com/intent/tweet?url=&text=" +
      encodeURIComponent(item.description);
    window.open(link, "_blank");
  }
  ddata:any
  changeStatus(item: any, value: any) {
    console.log(item, value);
    this.ddata = item
    let msg: string = "";
    if (value == 1) {
      msg = "Are you sure you want to enable the coupon?";
    } else if (value == 3) {
      msg = "Are you sure you want to disable the coupon?";
    }
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      width: "360px",
      data: {
        title: "Alert",
        message: msg,
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        this.isfromhere = true
        this.ddata = item
        let statusData = {
          couponHashId: item.hash_id,
          status: value,
          businessHashId: item.businessHashId
        };
        console.log(statusData);
        this.loader.showLoader = true;
        this._apiService.createAndUpdateCoupon(statusData);
      }
    });
  }
  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router
      .navigateByUrl("coupons", { skipLocationChange: true })
      .then(() => {
        this.router.navigate([currentUrl]);
      });
  }
  deleteCoupon(item: any, value: any) {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      width: "360px",
      data: {
        title: "Alert",
        message: "Are you sure you want to delete the coupon?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        this.isfromhere = true
        let statusData = {
          couponHashId: item.hash_id,
          status: value,
        };
        console.log(statusData);
        this.loader.showLoader = true;
        this._apiService.createAndUpdateCoupon(statusData);
      }
    });
  }

  // AddCoupon() {
  //   console.log("fire");
  //   let dialogRef = this.dialog.open(AddDiscountComponent, {

  //     disableClose: true,
  //   });
  // }

  AddCoupon() {
    console.log("fire");
    let dialogRef = this.dialog.open(AddDiscountComponent, {
      disableClose: true,
      width: "500px", // Set the dialog width to 500px
    });
    dialogRef.afterClosed().subscribe(data => {
      if(data){
        this._apiService.getDiscountCouponsList();
      }
    })
  }

  ngOnDestroy() {
    this.apiSubscription.unsubscribe();
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "",
        title: "Business profile",
      },
    });
  }

  opencontact() {
    this.router.navigate(["/contact-us"]);
  }
}
